import styled, { css } from 'styled-components/macro'
import { theme } from './theme'
import { mq } from './mq'

const headings = css`
  font-family: ${theme.fonts.headings};
  font-weight: 700;
  font-optical-sizing: auto;
  hyphens: none;
`

const body = css`
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  line-height: ${28 / 18};
  font-optical-sizing: auto;
`

export const typography = {
  headings,
  h1: css`
    ${headings}
    font-size: 3.6rem;
    line-height: ${42 / 36};

    ${mq.medium} {
      font-size: 6.4rem;
      line-height: 1.04;
    }
  `,
  h2: css`
    ${headings}
    font-size: 2.5rem;
    line-height: ${28 / 24};

    ${mq.medium} {
      font-size: 3.2rem;
    }
  `,
  h3: css`
    ${headings}
    text-align: left;
    font-size: 1.8rem;
    line-height: ${22 / 18};

    ${mq.medium} {
      font-size: 2.4rem;
      line-height: ${28 / 24};
    }
  `,
  body: css`
    ${body}
    font-family: ${theme.fonts.base};
    font-weight: normal;

    ${mq.large} {
      font-size: 2rem;
    }
  `,
  box: css`
    ${body}
    font-family: ${theme.fonts.box};
    font-weight: 300;
  `,
  boxSmall: css`
    font-family: ${theme.fonts.box};
    font-weight: 300;
    font-size: 1.4rem;

    ${mq.large} {
      font-size: 1.5rem;
    }
  `,
  label: css`
    font-size: 1.5rem;
    font-weight: 500;
  `,
  strong: css`
    font-weight: 500;
  `,
}
export const Light = styled.i`
  font-style: italic;
  font-weight: 300;
`
